"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NAMESPACE = void 0;

var _routes = _interopRequireDefault(require("./routes"));

var _epics = _interopRequireDefault(require("./epics"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var NAMESPACE = 'domains';
exports.NAMESPACE = NAMESPACE;
var _default = {
  route: _UrlPathParams.DOMAINS,
  reducer: _reducers.default,
  routes: _routes.default,
  rootEpic: _epics.default
};
exports.default = _default;